import React from 'react';
import styled from 'styled-components';
import Skeleton from '@material-ui/lab/Skeleton';

const Card = styled.div`
  .lineMargin {
    margin-top: 32px;
    margin-bottom: 24px;
  }
`;

const CommonSkeleton = () => (
  <Card>
    <Skeleton height={30} />
    <div className="lineMargin">
      <Skeleton height={5} />
    </div>
    <div style={{ display: 'flex' }}>
      <div style={{ width: '50%' }}>
        <Skeleton height={20} width="40%" />
        <div style={{ marginTop: '-15px' }}>
          <Skeleton height={60} width="80%" />
        </div>
      </div>
      <div style={{ width: '50%' }}>
        <Skeleton height={20} width="40%" />
        <div style={{ marginTop: '-15px' }}>
          <Skeleton height={60} width="80%" />
        </div>
      </div>
    </div>
    <div className="lineMargin">
      <Skeleton height={5} />
    </div>
    <Skeleton height={30} width="50%" />
    <div className="lineMargin">
      <Skeleton height={5} />
    </div>
    <div style={{ display: 'flex' }}>
      <div style={{ width: '50%' }}>
        <Skeleton height={30} width="80%" />
        <div style={{ marginTop: '-8px' }}>
          <Skeleton height={30} width="80%" />
        </div>
      </div>
      <div style={{ width: '50%' }}>
        <Skeleton height={30} width="80%" />
      </div>
    </div>
  </Card>
);

export default CommonSkeleton;
